// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"65":"4d1d6ba6","374":"044d77c3","376":"c1556c6d","534":"31d6cfe0","719":"183913d5"}[chunkId] + ".chunk.css";
};